import React from 'react';
import { Logger } from 'aws-amplify';
import { useSelector } from 'react-redux';
import { NotificationBadge } from '../../UI/Badges';
import { RootState } from '../../../store';
import { removeRedundancy } from '../../../utils/ArrayUtils';
import { isUnreadNotification } from '../../../utils/NotificationsUtils';

const logger = new Logger('FilesNotificationsBadge');

export const FilesNotificationBadge = () => {
  const fileNotifications = useSelector(
    (state: RootState) => state.notifications.fileNotifications,
  );

  const esigRequestNotifications = useSelector(
    (state: RootState) => state.notifications.esigRequestNotifications,
  );

  const esigRequestCompleteNotifications = useSelector(
    (state: RootState) => state.notifications.esigRequestCompleteNotifications,
  );

  const [
    filesNotificationsCounter,
    setFilesNotificationsCounter,
  ] = React.useState(0);

  /**
   * This method calculates for each notification
   * group its total unread notification, since files
   * and e-sign unread notifications are calculated differently.
   * Files unread notifications count is the sum of file-upload notified channel.
   * E-sign notifications count is the sum of esign-requests/signature complete actions
   * received at channel.
   */
  const calculateFilesNotificationsCounter = () => {
    logger.debug('Counting primary sidebar file notifications');
    logger.debug('Total file notifications:', fileNotifications.length);
    const unreadFileUploadNotifications = fileNotifications.filter(notif =>
      isUnreadNotification(notif),
    );
    logger.debug('Unread notifications:', unreadFileUploadNotifications.length);
    const fileUploadNotifiedChannelsIds = removeRedundancy(
      unreadFileUploadNotifications.map(notif => notif.fields.channelId),
    );
    logger.debug(
      'Unique Channel Ids without file upload notifications:',
      fileUploadNotifiedChannelsIds,
    );

    const unreadEsigRequestNotifications = esigRequestNotifications.filter(
      notif => isUnreadNotification(notif),
    );

    const unreadEsigRequestCompleteNotifications = esigRequestCompleteNotifications.filter(
      notif => isUnreadNotification(notif),
    );

    const totalFileUploadNotificationsCount =
      fileUploadNotifiedChannelsIds.length;
    const totalEsignRequestNotificationsCount =
      unreadEsigRequestNotifications.length;
    const totalEsignRequestCompleteNotificationsCount =
      unreadEsigRequestCompleteNotifications.length;

    const totalFilesNotificationsCount =
      totalFileUploadNotificationsCount +
      totalEsignRequestNotificationsCount +
      totalEsignRequestCompleteNotificationsCount;

    setFilesNotificationsCounter(totalFilesNotificationsCount);
  };
  React.useEffect(() => {
    calculateFilesNotificationsCounter();
  }, [
    fileNotifications,
    esigRequestNotifications,
    esigRequestCompleteNotifications,
  ]);

  return (
    <NotificationBadge
      showZero={false}
      isSidebar
      content={filesNotificationsCounter}
    />
  );
};
